import React from 'react';
import './Marquee.css'; // The broken import has been completely removed!

// Import company icons
import wiproIcon from '../utility/companyIcons/wipro.png';
import tcsIcon from '../utility/companyIcons/tcs.png'; // <-- FIXED: Added .png
import msIcon from '../utility/companyIcons/microsoft.png';
import deloitteIcon from '../utility/companyIcons/deloitte.png';
import capgeminiIcon from '../utility/companyIcons/capgemini.png';
import infosysIcon from '../utility/companyIcons/infosys.png';
import accentureIcon from '../utility/companyIcons/accenture.png';
import ibmIcon from '../utility/companyIcons/ibm.png'; // <-- FIXED: Added .png

// 1. Define the COMPANIES array locally so you don't need external files
const COMPANIES = [
  { name: 'Wipro' },
  { name: 'TCS' },
  { name: 'Microsoft' },
  { name: 'Deloitte' },
  { name: 'Capgemini' }, // <-- FIXED: Corrected spelling
  { name: 'Infosys' },
  { name: 'Accenture' },
  { name: 'IBM' }
];

const Marquee = () => {
  // Map company icons
  const companyIconMap = {
    'Wipro': wiproIcon,
    'TCS': tcsIcon,
    'Microsoft': msIcon,
    'Deloitte': deloitteIcon,
    'Capgemini': capgeminiIcon, // <-- FIXED: Matches the corrected spelling above
    'Infosys': infosysIcon,
    'Accenture': accentureIcon,
    'IBM': ibmIcon
  };

  // Duplicate companies to create a seamless loop
  const doubledCompanies = [...COMPANIES, ...COMPANIES];


  return (
    <section className="marquee-section">
      <h2 className="marquee-title">Our Placement Partners</h2>
      <div className="marquee-container">
        <div className="marquee">
          <div className="marquee-content">
            {doubledCompanies.map((company, index) => (
              <div key={index} className="company-item">
                {companyIconMap[company.name] ? (
                  <img
                    src={companyIconMap[company.name]}
                    alt={`${company.name} logo`}
                    className="company-logo-img"
                  />
                ) : (
                  <span className="company-logo">{company.name}</span>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Marquee;